<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Turma</e-label>
                    <p class="font-weight-regular">
                      <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${gestaoSelecionada?.turma?.franquia?.descricao}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="gestaoSelecionada"
                          autocomplete="off"
                          :error-messages="errors"
                        ></v-select>
                      </ValidationProvider>
                    </p>
                  </v-col>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ aula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <!-- <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Data</e-label>
                      <e-date-picker v-model="dataAulaDuplicada" :error-messages="errors" />
                    </ValidationProvider>
                  </v-col> -->

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Selecione uma data</e-label>
                        <ValidationProvider
                          name="Data da aula"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            dense
                            solo
                            v-model="data_aula"
                            label="data"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!gestaoSelecionada?.id"
                            autocomplete="off"
                            :error-messages="errors"
                            readonly
                          ></v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-date-picker
                        color="primary"
                        v-model="dataAulaDuplicada"
                        scrollable
                        :allowed-dates="allowedDates"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col class="pt-0 pb-0" v-if="aula.tipo_de_aula !== 'Aula Remota'" cols="6">
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <v-select
                        :items="horarios"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        :disabled="!gestaoSelecionada?.id"
                        @change="() => pesquisaAulas()"
                        solo
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- Conteudo da aula -->
                <div>
                  <e-conteudo-aula-infantil v-if="aulaInfantil" :aula="aula" />
                  <e-conteudo-aula-polivalente v-if="aula.is_polivalencia" :aula="aula" />
                  <e-conteudo-aula-regular v-else :aula="aula" />
                </div>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperadosFiltrados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false), limparCampos()"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="submittingForm || conflitouAula || !totalmentePreenchido"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
import EConteudoAulaInfantil from "./EConteudoAulaInfantil.vue";
import EConteudoAulaRegular from "./EConteudoAulaRegular.vue";
import EConteudoAulaPolivalente from "./EConteudoAulaPolivalente.vue";

export default {
  components: { EConteudoAulaInfantil, EConteudoAulaRegular, EConteudoAulaPolivalente },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      date: null,
      dataAulaDuplicada: null,
      modal: false,
      menu: false,
      aula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      gestaoSelecionada: {},
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      horarios: [],
      datasPermitidas: [],
      conflitouAula: false,
      itemsEsperados: [
        { label: "Turma", value: "gestaoSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperadosFiltrados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  computed: {
    allowedDates() {
      return (val) => this.diasPermitidosParaCriarAula.includes(new Date(val).getDay());
    },
    aulaInfantil() {
      return this.aula.e_aula_infantil === 1;
    },
    aulaRemota() {
      return this.aula?.tipo_de_aula === "Aula Remota";
    },
    itemsEsperadosFiltrados() {
      if (this.aulaRemota) {
        return this.itemsEsperados.filter((item) => item.value !== "horarioSelecionado");
      }
      return this.itemsEsperados;
    },
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aula = val;
      },
    },
    gestaoSelecionada: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.diasPermitidosParaCriarAula = val.relacoesDiasHorarios?.map((g) => g.dia.id);
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.aula
            );
            this.turmas = gestoes.filter(
              (gestao) => gestao.id !== this.form.instrutorDisciplinaTurma_id
            );
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(value) {
      if (!value) return;
      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.data_aula = data_old.replaceAll("/", "/");
      this.pesquisaAulas();
      this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay());
    },
  },
  methods: {
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      this.horarioSelecionado = null;
      this.horarios = this.gestaoSelecionada?.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);
    },
    enableSubmit() {
      this.confirmDialog = !this.confirmDialog;
      this.aula.data = this.dataAulaDuplicada;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        this.aula.horario_inicial = this.horarioSelecionado ? this.horarioSelecionado.inicio : null;
        this.aula.horario_final = this.horarioSelecionado ? this.horarioSelecionado.final : null;
        this.aula.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aula.instrutorDisciplinaTurma_id = parseInt(this.gestaoSelecionada.id, 10);
        this.aula.turma_id = this.gestaoSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        await this.$services.aulasService.criar(this.aula);

        this.$emit("dialogChange", false);
        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async pesquisaAulas() {
      if (!this.dataAulaDuplicada || !this.horarioSelecionado || !this.gestaoSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
        this.dataAulaDuplicada,
        this.horarioSelecionado.id,
        this.gestaoSelecionada.turma.id,
        null // sem aula_id
      );

      if (response.data?.length === 0) {
        this.conflitouAula = false;
        this.$emit("conflitouAula", { status: false, conflitos: [] });
      } else {
        this.conflitouAula = true;
        this.$emit("conflitouAula", { status: true, conflitos: response.data });
      }
    },
    limparCampos() {
      this.data_aula = null;
      this.gestaoSelecionada = null;
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = null;
      this.totalmentePreenchido = false;
      this.conflitouAula = false;
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
  },
};
</script>
